import React from 'react';

import { useTranslation, Trans } from "react-i18next";

import i1 from '../../img/MansoryMesh/i1.webp';
import i2 from '../../img/MansoryMesh/i2.webp';
import i3 from '../../img/MansoryMesh/i3.webp';

function ApplicationsMasonryMesh () {

    const { t } = useTranslation();
      
    return(
        <div className="bg-[#1D1D1D] pt-[100px] xl:pt-[200px]">
            <div className="max-w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto">
                <div className="flex items-center justify-center">
                    <p className="text-[28px] xl:text-[45px] open-sans text-[#F26522] text-center leading-[1.4]">
                        <Trans>{t("mansorymesh.add.8")}</Trans>
                    </p>
                </div>
                <div className='flex flex-wrap justify-center xl:justify-between items-center mt-[30px] xl:mt-[70px] gap-[30px]'>
                    <div className='flex flex-col items-center'>
                        <img src={i1} alt="" />
                        <p className='mt-[20px] max-w-[255px] font-[300] text-[#F6F6F6] text-[14px] xl:text-[16px] text-center'>{t('mansorymesh.add.9')}</p>
                    </div>
                    <div className='flex flex-col items-center'>
                        <img src={i2} alt="" />
                        <p className='mt-[20px] max-w-[255px] font-[300] text-[#F6F6F6] text-[14px] xl:text-[16px] text-center'>{t('mansorymesh.add.10')}</p>
                    </div>
                    <div className='flex flex-col items-center'>
                        <img src={i3} alt="" />
                        <p className='mt-[20px] max-w-[255px] font-[300] text-[#F6F6F6] text-[14px] xl:text-[16px] text-center'>{t('mansorymesh.add.11')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ApplicationsMasonryMesh;